import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SearchFormBase } from '../../../../../components/common/search-form-base/search-form-base';
import * as moment from 'moment';
import { AppServiceHelperService } from '../../../../../services/app-service-helper.service';
import { EventBusService } from '../../../../../services/event-bus.service';
import { AppStorageService } from '../../../../../services/app-storage.service';
import { take } from 'rxjs';

/**
 * VE search form
 */
@Component({
  selector: 'portfolios-search-form',
  templateUrl: './portfolios-search-form.component.html',
  styleUrls: ['./portfolios-search-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PortfoliosSearchFormComponent extends SearchFormBase<any> implements OnInit {
  /**
   * Search event name (event bus)
   */
  protected get searchEventName(): string {
    return 'project.valuation.search';
  }

  /**
   * Show all event name (event bus)
   */
  protected get showAllEventName(): string {
    return 'project.valuation.showAll';
  }

  /**
   * The user
   */
  public user: any;

  /**
* Selected item type
*/
  @Input() selectedItemType: string;

  /**
  * Selected item
  */
  @Input() selectedItem: any;

  /**
   * Gets the filter object
   * @param form
   * @returns
   */
  protected getFilterObject(form: UntypedFormGroup) {
    const filter = {
      logic: "and",
      filters: [],
      serverFilters: []
    };

    if (this.selectedItemType === 'projectstd') {
      filter.filters.push({ field: 'ProjectID', value: this.selectedItem.Oid, operator: "contains" });
    } else if (form.get('projectId').value) {
      filter.filters.push({ field: 'ProjectIDDescription', value: form.get('projectId').value, operator: "contains" });
    }


    this.addFilterNoStorage(filter, form, 'valuationPortfolioName', 'ValuationPortfolioName', 'contains');
    this.addFilterNoStorage(filter, form, 'valuationPortfolioOid', 'Oid', 'equals');

    if (form.get('valuationDate').value != '' && form.get('valuationDate').value != null) {
      //kendo-datepicker keeps value as date in contast to <input type="date"> which keeps value as yyyy-MM-dd string
      const valuationDate = moment(form.get('valuationDate').value).format('YYYY-MM-DD');
      filter.filters.push({
        field: 'ValuationDate',
        operator: "contains",
        serverValue: `{ fromDate: '${valuationDate}', toDate: '${valuationDate}' }`
      });
    }
    this.addFilterNoStorage(filter, form, 'clientIdDescription', 'ClientManual', 'contains');
    this.addFilterNoStorage(filter, form, 'valuationStatusId', 'ValuationStatusId', 'eq');
    this.addFilterNoStorage(filter, form, 'recordStatus', 'RecordStatusId', 'eq');

    if (form.get('projectLeader').value != 0 && form.get('projectLeader').value != null) {
      filter.filters.push({ field: 'TeamList', value: ';' + form.get('projectLeader').value + ':1', operator: "contains" });
    }
    if (form.get('teamMember').value != 0 && form.get('teamMember').value != null) {
      filter.filters.push({ field: 'TeamList', value: ';' + form.get('teamMember').value + ':', operator: "contains" });
    }

    return filter;
  }

  /**
   *
   * Creates the FormGroup
   * @param data
   * @returns
   */
  protected createFormGroup(data: any): UntypedFormGroup {
    return new UntypedFormGroup({
      projectId: new UntypedFormControl(data.projectId),
      valuationDate: new UntypedFormControl(data.valuationDate),
      valuationPortfolioName: new UntypedFormControl(data.valuationPortfolioName),
      valuationPortfolioOid: new UntypedFormControl(data.valuationPortfolioOid),
      clientIdDescription: new UntypedFormControl(data.clientIdDescription),
      valuationStatusId: new UntypedFormControl(data.valuationStatusId),
      recordStatus: new UntypedFormControl(data.recordStatus),
      projectLeader: new UntypedFormControl(data.projectLeader),
      teamMember: new UntypedFormControl(data.teamMember)
    });
  }

  /**
   * Resets the form
   */
  protected reset(): void {
    this.formData.controls['projectId'].setValue('');
    this.formData.controls['valuationDate'].setValue(null);
    this.formData.controls['valuationPortfolioName'].setValue('');
    this.formData.controls['valuationPortfolioOid'].setValue('');
    this.formData.controls['clientIdDescription'].setValue('');
    this.formData.controls['valuationStatusId'].setValue(0);
    this.formData.controls['recordStatus'].setValue(0);
    this.formData.controls['projectLeader'].setValue(0);
    this.formData.controls['teamMember'].setValue(0);

    this.appStorage.setSelectedProject(null);
    this.appStorage.setSelectedPortfolio(null);
  }

  /**
   * Initializes the form data
   * @returns
   */
  protected initFormData(): Promise<any> {
    return new Promise<any>((resolve) => {
      const values = {
        projectId: '',
        valuationDate: null,
        valuationPortfolioName: '',
        valuationPortfolioOid: '',
        clientIdDescription: '',
        valuationStatusId: 0,
        recordStatus: 0,
        projectLeader: 0,
        teamMember: 0
      };
      resolve(values);
    });
  }

  /**
   * Constructor
   * @param httpClient Angular HttpClient
   */
  constructor(private appStorage: AppStorageService, eventBus: EventBusService, httpClient: HttpClient, appServiceHelper: AppServiceHelperService) {
    super(eventBus, httpClient, 'resetValuationSearchMode', appServiceHelper);
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.requireReflist('ref_portfolio_valuation_status');
    this.requireReflist('ref_recordstatus');
    this.loadUsers().pipe(take(1)).subscribe((usersList: any[]) => {
      this.user = usersList.filter((user) => user.isActive);
      this.init().then(() => {
        //Nothing
      });
    });
  }
}
